<template>
  <c-q-btn
    v-if="showDistributionButton"
    id="btn-view-institutional-distribution"
    propBtnLabel="Distribuição do Cadastro"
    :propBtnFunction="onViewInstitutionalDistribution"
    :propBtnTransparent="false"
    :propBtnSize="EnumButtonSizes.LARGE_1"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { EnumButtonSizes, EnumRouteNames } from '@/enums/enums'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { useAuthStore } from '@/stores/authStore'

import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'

const institutionalStore = useInstitutionalStore()
const authStore = useAuthStore()
const router = useRouter()

/**
 * ✅ REGRA DE EXIBIÇÃO
 */
const showDistributionButton = computed(() => {
  const status = institutionalStore.institutionalDetail?.status

  return (
    authStore.currentUserCanViewInstitutional &&
    !!status &&
    (
      status === CONST_INSTITUTIONAL_STATUS.PUBLISHED.id ||
      status === CONST_INSTITUTIONAL_STATUS.ACTIVE_INSTITUTIONAL.id ||
      status === CONST_INSTITUTIONAL_STATUS.PENDING_PUBLICATION.id ||
      status === CONST_INSTITUTIONAL_STATUS.INSTITUTIONAL_COMPLETED.id
    )
  )
})

/**
 * ✅ IR PARA DISTRIBUIÇÃO
 */
const onViewInstitutionalDistribution = () => {
  const id = institutionalStore.institutionalDetail?.id

  if (!id) return

  router.push({
    name: EnumRouteNames.INSTITUTIONAL_DISTRIBUTION,
    params: { id }
  })
}
</script>

<style scoped>
</style>